/**
 * Снимок для сравнения: код редактора + текстовый ответ (поле в условии).
 */
export function buildAttemptSnapshot(codeSnapshot, studentTextAnswer) {
  return `${String(codeSnapshot ?? '').trim()}\n---\n${String(studentTextAnswer ?? '').trim()}`;
}

/**
 * Загрузить последнюю попытку по задаче и пункту списка.
 */
export async function fetchLatestAttempt(api, taskSlug, listItemId) {
  const params = { task: taskSlug };
  if (listItemId) params.task_list_item = listItemId;
  const res = await api.get('/tasks/attempts/', { params });
  const arr = Array.isArray(res.data) ? res.data : res.data?.results ?? [];
  return arr[0] ?? null;
}

/**
 * POST новая попытка или PATCH последней, если снимок совпадает.
 * testsResult — объект для merge в tests_result (runner + answer_*).
 */
export async function recordTaskAttempt(api, payload) {
  const {
    taskSlug,
    taskId,
    listItemId,
    lessonSessionId,
    codeSnapshot,
    studentTextAnswer,
    selfReportStatus,
    selfComment,
    testsResult,
  } = payload;

  const latest = await fetchLatestAttempt(api, taskSlug, listItemId);
  const newSnap = buildAttemptSnapshot(codeSnapshot, studentTextAnswer);
  const oldSnap = latest
    ? buildAttemptSnapshot(latest.code_snapshot, latest.tests_result?.student_text_answer)
    : null;

  const mergedForPatch =
    latest && typeof latest.tests_result === 'object' && latest.tests_result !== null
      ? { ...latest.tests_result, ...(testsResult || {}) }
      : { ...(testsResult || {}) };
  if (studentTextAnswer !== undefined && studentTextAnswer !== null) {
    mergedForPatch.student_text_answer = String(studentTextAnswer);
  }

  if (latest && newSnap === oldSnap) {
    await api.patch(`/tasks/attempts/${latest.id}/`, {
      self_report_status: selfReportStatus ?? latest.self_report_status,
      self_comment: selfComment !== undefined ? selfComment : latest.self_comment,
      code_snapshot: String(codeSnapshot ?? ''),
      tests_result: mergedForPatch,
    });
    return { mode: 'patch', id: latest.id };
  }

  const mergedForPost = { ...(testsResult || {}) };
  if (studentTextAnswer !== undefined && studentTextAnswer !== null) {
    mergedForPost.student_text_answer = String(studentTextAnswer);
  }

  await api.post('/tasks/attempts/', {
    task: taskId,
    lesson_session: lessonSessionId ? Number(lessonSessionId) : null,
    task_list_item: listItemId,
    code_snapshot: String(codeSnapshot ?? ''),
    tests_result: mergedForPost,
    self_report_status: selfReportStatus ?? 'NOT_TRIED',
    self_comment: selfComment || '',
  });
  return { mode: 'post' };
}

/** MVP: нормализация для сравнения с expected_answer */
export function normalizeAnswerText(s) {
  return String(s ?? '')
    .trim()
    .replace(/\s+/g, ' ')
    .toLowerCase();
}

export function checkAnswerAgainstExpected(studentAnswer, expectedAnswer) {
  if (expectedAnswer == null || String(expectedAnswer).trim() === '') return null;
  return normalizeAnswerText(studentAnswer) === normalizeAnswerText(expectedAnswer);
}
